import { Check, X } from 'lucide-react';

interface ApprovalCountsDisplayProps {
  approvals: number;
  rejections: number;
  threshold: number;
}

export function ApprovalCountsDisplay({
  approvals,
  rejections,
  threshold,
}: ApprovalCountsDisplayProps) {
  return (
    <div className="flex flex-col items-stretch gap-1 max-w-fit text-sm font-medium text-muted-foreground text-xs">
      <div className="flex border-none bg-transparent items-center gap-1 text-muted-foreground whitespace-nowrap shadow-none font-normal">
        <Check className="h-3 w-3" strokeWidth={2} />
        Approved by{' '}
        <span className="font-medium text-primary">
          {approvals}/{threshold}
        </span>
      </div>
      <div className="flex border-none bg-transparent items-center gap-1 text-muted-foreground whitespace-nowrap shadow-none font-normal">
        <X className="h-3 w-3" strokeWidth={2} />
        Rejected by{' '}
        <span className="font-medium text-primary">
          {rejections}/{threshold}
        </span>
      </div>
    </div>
  );
}
